import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function ChartError({ error, title = "Unable to display chart" }) {
  return (
    <Box sx={{ my: 2 }}>
      <Alert 
        severity="warning" 
        icon={<ErrorOutlineIcon />}
        sx={{ 
          borderRadius: 2,
          '& .MuiAlert-icon': {
            fontSize: '1.5rem'
          }
        }}
      >
        <AlertTitle>{title}</AlertTitle>
        {error || 'An error occurred while rendering the chart. The data is still available in the text response above.'}
      </Alert>
    </Box>
  );
}